(() => {
  const instances = new Map();
  function init() {
    const header = document.querySelector('.tms-header');
    if (!header || instances.has(header)) return;
    const controller = new AbortController(); const signal = controller.signal;
    const button = header.querySelector('[data-tms-menu-toggle]');
    const menu = header.querySelector('[data-tms-mobile-menu]');
    if (button && menu) {
      const close = () => { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', button.dataset.openLabel); };
      button.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; button.setAttribute('aria-expanded', String(open)); button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel); }, { signal });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !menu.hidden) { close(); button.focus(); } }, { signal });
      menu.addEventListener('click', (event) => { if (event.target.closest('a')) close(); }, { signal });
      matchMedia('(min-width:801px)').addEventListener('change', (event) => { if (event.matches) close(); }, { signal });
    }
    header.querySelector('.tms-language-form')?.addEventListener('submit', (event) => {
      const returnTo = event.currentTarget.querySelector('[name=return_to]');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search;
    }, { signal });
    header.querySelectorAll('.tms-nav a,.tms-mobile-nav a').forEach((link) => {
      if (new URL(link.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '') && new URL(link.href).search === location.search) link.setAttribute('aria-current', 'page');
    });
    instances.set(header, () => controller.abort());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => { for (const [header, destroy] of instances) if (event.target.contains(header)) { destroy(); instances.delete(header); } });
})();
